module.exports = __webpack_public_path__ + "media/Planning_2.0_to_2A.87c04d56.mp4";